export default __webpack_public_path__ + "static/media/clock-gray-icon.95814fbe.svg";